class LocalStorage {
  get(name) {
    try {
      const serializedState = localStorage.getItem('vue_state' + name)

      if (serializedState === null) {
        return []
      }

      return JSON.parse(serializedState)
    } catch (err) {
      return []
    }
  }

  set(name, state) {
    try {
      const serializedState = JSON.stringify(state)

      localStorage.setItem('vue_state' + name, serializedState)
    } catch (err) {
      console.error(`Something went wrong: ${err}`)
    }
  }
}

export const localstorage = new LocalStorage()
